import { Component, OnInit } from '@angular/core';

interface BootcampCourse {
image: string;
title: string;
highlight: string;
features:string[];
price: string;
bookLink?: string; // Optional link for booking
detailsLink?: string; // Optional link for more details
}

@Component({
    selector: 'app-bridge-course',
    templateUrl: './bridge-course.component.html',
    styleUrls: ['./bridge-course.component.css'],
    standalone: false
})
export class BridgeCourseComponent {

  bootcampCourses: BootcampCourse[] = [
    {
      image: 'assets/images/br-course.png',
      title: 'Bridge to YEAR 5',
      highlight: 'Verbal Reasoning (VR)',
      features: [
        'Master Verbal Reasoning',
        'Real Exam Practice',
        'Track Progress With RAR',
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/569c3816e2a9deb2910d7d020a847f61/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/569c3816e2a9deb2910d7d020a847f61'
    },
    {
      image: 'assets/images/br-course.png',
      title: 'Bridge to YEAR 5',
      highlight: 'MATHS',
      features: [
        'Master Key Maths Concepts',
        'Strengthen Problem-Solving Skills',
        'Build Exam Confidence'
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fc5bc01f1864701ae9db57d33efed4d3/book-a-slot',
      detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/fc5bc01f1864701ae9db57d33efed4d3'
    },
    {
      image: 'assets/images/br-course.png',
      title: 'Bridge to YEAR 5',
      highlight: '(English (ERC & CW) + Grammar',
      features: [
        'Sharpen Logical Thinking',
        'Build Vocabulary Skills',
        'Boost Accuracy and Speed'
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/01ffb0578c6704da0b201c226c201670/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/01ffb0578c6704da0b201c226c201670'
    },
    {
      image: 'assets/images/br-course.png',
      title: 'Bridge to YEAR 5',
      highlight: 'Non Verbal Reasoning (NVR)',
      features: [
        'Master Non Verbal Reasoning',
        'Real Exam Practice',
        'Track Progress With RAR',
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/b8fc78cb761e12b00496119ee93f99e1/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/b8fc78cb761e12b00496119ee93f99e1'
    },
  ];


}
